import { css } from 'styled-system/css';
import andrePortrait from '../../assets/andre-staltz.jpg';

export function FounderPortrait() {
  return (
    <figure
      className={css({
        display: 'flex',
        flexDirection: { base: 'row', lg: 'column' },
        alignItems: { base: 'center', lg: 'flex-start' },
        gap: { base: '4', lg: '5' },
        margin: '0',
      })}
    >
      <div
        className={css({
          flexShrink: '0',
          padding: '1px',
          background: 'var(--prism-ring)',
        })}
      >
        <img
          src={andrePortrait}
          alt="Portrait of Andre Staltz"
          width={256}
          height={256}
          className={css({
            display: 'block',
            width: { base: '14', lg: '32' },
            height: 'auto',
            aspectRatio: '1',
            objectFit: 'cover',
            background: 'bg.subtle',
          })}
        />
      </div>
      <figcaption
        className={css({
          fontSize: 'sm',
          lineHeight: 'snug',
          color: 'text.secondary',
        })}
      >
        <span
          className={css({ color: 'text.primary', fontWeight: 'semibold' })}
        >
          Andre Staltz
        </span>
        , Founder
      </figcaption>
    </figure>
  );
}
